import { render, staticRenderFns } from "./orderdetail.vue?vue&type=template&id=5fa186f6&scoped=true&"
import script from "./orderdetail.vue?vue&type=script&lang=js&"
export * from "./orderdetail.vue?vue&type=script&lang=js&"
import style0 from "./orderdetail.vue?vue&type=style&index=0&id=5fa186f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa186f6",
  null
  
)

export default component.exports